import { api } from "@/lib/api";

export const fileSrc = (url) => `${process.env.REACT_APP_BACKEND_URL}${url}`;

export const fmtSize = (b = 0) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

// Refresh an expired sign-in before the browser fetches the file directly.
export const openFile = async (url, download = false) => {
  const w = download ? null : window.open("", "_blank");
  await api.get("/resources").catch(() => {});
  const src = `${fileSrc(url)}${download ? "?download=1" : ""}`;
  if (w) w.location.href = src; else window.location.href = src;
};

const CHUNK = 4 * 1024 * 1024;
const hexId = () => Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");

export const uploadPdf = async (file, onProgress) => {
  const id = hexId();
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let out = null;
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append("upload_id", id); fd.append("index", i); fd.append("total", total); fd.append("filename", file.name);
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    out = (await api.post("/resources/uploads/chunk", fd)).data;
    onProgress(Math.round(((i + 1) / total) * 100));
  }
  return out;
};
